// src/lib/authBoot.ts

let authReadyResolve: (() => void) | null = null;

export const authReady = new Promise<void>((resolve) => {
  authReadyResolve = resolve;
});

export function markAuthReady() {
  if (authReadyResolve) {
    authReadyResolve();
    authReadyResolve = null; 
  }
}
